import React, { useEffect, useState } from 'react'
import { makeStyles, Tooltip } from '@material-ui/core'

const useStyles = makeStyles(theme => {
  return {
    toggle: {
      padding: '5px 9px !important',
      background: '#F3F3F3',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'center',
      alignItems: 'center',
      cursor: 'pointer',
      borderRadius: 20,
    },
    indicator: {
      width: 16,
      height: 16,
      borderRadius: '100%',
      marginRight: 4,
    },
    text: {
      fontSize: 12,
      lineHeight: '18px',
      fontWeight: 400,
      color: '#474747',
    },
  }
})

interface ToggleButtonProps {
  activeColor: any
  inactiveColor: any
  setToggleValue: any
  title: any
  toggleState: boolean
  spaceLeft: number
  spaceRight: number
}

const ToggleButton = ({
  activeColor,
  toggleState,
  inactiveColor,
  setToggleValue,
  title,
  spaceLeft,
  spaceRight,
}: ToggleButtonProps) => {
  const classes = useStyles()
  const [toggle, setToggle] = useState(true)

  const onToggle = () => {
    setToggle(!toggle)
    setToggleValue(!toggle)
  }

  useEffect(() => {
    setToggle(toggleState)
  }, [toggleState])

  return (
    <Tooltip
      title={toggle ? 'Click to disable' : 'Click to enable'}
      arrow
      placement="top"
    >
      <div
        onClick={() => onToggle()}
        className={classes.toggle}
        style={{ marginLeft: `${spaceLeft}px`, marginRight: `${spaceRight}px` }}
      >
        <div
          className={classes.indicator}
          style={{ background: !toggle ? inactiveColor : activeColor }}
        />

        <span className={classes.text}>{title}</span>
      </div>
    </Tooltip>
  )
}

export default ToggleButton
